// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"FP","mainContent":"GP","activeSidebar":"HP"};